export const appBaseUri = "cdqapp://";
export const appDefaultConnectedRoute = "/clients";
export const appDefaultOfflineUrl = '/offline/home';
export const appDefaultOfflineUrlMobile = '/offline/starter';

